export default {
  1: 'en',
  2: 'ar',
  3: 'fr',
};
